<template>
    <v-app>
        <div id="container">
            <v-img
                    alt="GameEnable"
                    class="shrink mr-2"
                    contain
                    src="../../assets/logo/one-line-dark.svg"
                    transition="scale-transition"
                    width="180"
                    style="position:absolute;left:0;    margin: 17px 17px 17px 20px;"
            />
            <div style="position: absolute; top: 90px;width: 100%;">

                <h4 style="font-size:24px;color:#fff;text-align:center;"> Thank you for Choosing GameEnable!</h4>
                <br>
                <h3 style="color:#fff;font-weight:300;text-align:center;"> To setup GameEnable VPN you'll need to follow two simple steps. Let's go.</h3>
            </div>
            <br>


            <div style="margin-top: 215px;margin-bottom:30px;" class="">
                <v-stepper
                        style="max-width:500px;position:relative;margin:80px auto 0 auto;"
                        v-model="step"
                        dark
                        color="pink"
                        vertical
                >
                    <v-stepper-step
                            :complete="signedIn"
                            step="1"
                            color="pink"
                            style="position:relative;"
                    >
                        Sign in
                        <small style="    font-size: 13px;">If you already have an account, use the same Gmail account to sign in</small>
                        <v-btn v-if="signedIn" @click="onChangeAccount" text color="pink pa0" style="float: right;font-size: 10px;position: absolute;    right: 42px;top: 22px;padding: 0px;height: 15px;font-size: 13px;">Change account</v-btn>
                    </v-stepper-step>

                    <v-stepper-content step="1">
                        <v-card
                                color="transparent elevation-0 pt-10"
                                class="mb-12"
                                height="100px"
                        >   <sign-in-button @completed="signInCompleted" :source="'extension'" ></sign-in-button></v-card>

                    </v-stepper-content>

                    <v-stepper-step
                            :complete="step > 2"
                            step="2"
                            color="pink"
                    >
                        Verify subscription
                    </v-stepper-step>

                    <v-stepper-content step="2">
                        <span v-if="initialized">
                        <span v-if="!paymentFormOpen">
                             <v-card
                                     color="transparent pt-4 elevation-0"
                                     class="mb-12"

                             >
                            You don't seem to have a subscription yet.
                            <br>
                            Get one now!



                        </v-card>
                        <v-btn class="action-button" id="purchase-button" style="width:250px!important;" @click="paymentFormOpen=true" v-text="'Get subscription'"> </v-btn>
                        </span>
                      <div v-if="paymentFormOpen" style="overflow: hidden; margin-bottom: -30px;height: 430px;">
                          <payment-form dark-theme="true" sourc="setup-page" :signInToken="signInToken" @completed="subscriptionCompleted" ></payment-form>
                      </div>
                            </span>
                        <span v-if="!initialized">
                            <v-progress-circular
                                    indeterminate
                                    color="pink"
                            ></v-progress-circular>

                        </span>

                        <br>
                    </v-stepper-content>

                    <v-stepper-step
                            :complete="step > 3"
                            step="3"
                            color="pink"
                    >
                        Connect
                    </v-stepper-step>

                    <v-stepper-content step="3">
                        <v-card
                                color="transparent pt-4 elevation-0"
                                class="mb-12"

                        >
                            Finding our fastest server.
                            <br>
                            This process may take <u><b>up to 60 seconds</b></u> to complete
                            <div v-if="connectingToVPN" style="position: absolute; left: 0; right: 0; margin: auto; width: 100px; margin-top: 14px;">

                             <v-progress-circular
                                     indeterminate
                                     color="pink"
                             ></v-progress-circular>
                        </div>


                        </v-card>

                    </v-stepper-content>

                    <v-stepper-step
                            :complete="step > 3"
                            step="4"
                            color="pink"
                    >
                        Let's play!
                    </v-stepper-step>

                    <v-stepper-content step="4">

                        <v-card
                                color="transparent pt-4 elevation-0"
                                class="mb-12"

                        >
                            Your VPN is ready to work.
                            <br>
                            Navigate to your gaming service and start playing!



                        </v-card>
                        <div style=" position: relative;top: -21px;">Go to:</div>
                        <div style="display: flex;justify-content: space-between;">
                            <a target="_blank" href="https://stadia.google.com" rel="noreferrer" class="action-button" style="width: 130px !important;position: relative;margin: 0px auto;">Stadia</a>
                            <a target="_blank" href="https://play.geforcenow.com" rel="noreferrer" class="action-button" style="width: 130px !important;position: relative;margin: 0px auto;">GeforceNOW </a>
                            <a target="_blank" href="https://xbox.com/en-US/play" rel="noreferrer" class="action-button" style="width: 130px !important;position: relative;margin: 0px auto;">xCloud</a>
                        </div>
                    </v-stepper-content>

                </v-stepper>
            </div>

        </div>
        <v-snackbar
                v-model="vpnConnectedSnackbar"

                color="success"
        >
            VPN connected

            <template v-slot:action="{ attrs }">
                <v-btn

                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        <extension-not-controllable-dialog v-model="notControllableDialog" :canRetry="true" @retry="connectRetry"></extension-not-controllable-dialog>
    </v-app>
</template>

<style>

    #container {
        max-height: 100vh;
        overflow: auto;
    }

    .container {


        height:100%;
        display:flex;
        justify-content:center;
        align-items:center;

    }

    .product-description{
        margin: 1px!important;
    }

    .dark-theme .payment-button-container {
        bottom: 39px !important;
        margin: 0;
        width: 100%!important;
        position: relative;
    }

</style>

<script>
    // @ is an alias to /src

    import ExtensionBridge from './extensionBridge'
    import PaymentForm from '../../components/paymentForm'
    import SignInButton from '../../components/signInButton'
    import {mapState} from 'vuex'
    import ExtensionNotControllableDialog from '../../dialogs/extensionNotControllable'

	export default {
        name: 'Extension_Setup_VPN',
        components: {
            PaymentForm,
            SignInButton,
            ExtensionNotControllableDialog
		},
        computed: {
            ...mapState(['user', 'signedIn', 'signInToken', 'initialized'])
        },
        created(){

            if(this.signedIn){
                this.step = 2;


            }

        },
        data: () => ({
            step:1,
            paymentFormOpen: false,
            vpnConnectedSnackbar: false,
            connectingToVPN: false,
            notControllableDialog: false
        }),
        watch:{
            initialized(){
                this.step = this.user.haveSubscription? 3 : 2;

                ExtensionBridge.syncUserState(this.user);

                if(this.step === 3){
                    this.connectToVPN();
                }
            }
        },
        methods: {
            onChangeAccount(){
                this.$store.dispatch('signOut', {navigate: false});
                ExtensionBridge.clearUserState();
                this.step = 1;
            },
            async signInCompleted(payload){

                this.$store.dispatch('signIn', payload);

                this.step = this.user.haveSubscription? 3 : 2;

                ExtensionBridge.syncUserState(this.user);

                if(this.user.haveSubscription){

                    await this.connectToVPN();

                }

            },
            async connectToVPN(){
                this.connectingToVPN = true;
                const response = await ExtensionBridge.connect();

                if(response.notControllable){

                    this.notControllableDialog=true;
                    return;

                }
                this.vpnConnectedSnackbar = true;

                this.connectingToVPN = false;
                this.step = 4;
            },
            async subscriptionCompleted(){

                this.step = 3;

                this.$store.commit('setHaveSubscription', true);
                ExtensionBridge.subscriptionCreated();

                await this.connectToVPN();

            },
            connectRetry(){

                this.notControllableDialog = false;

                this.connectToVPN();

            }
        }
    }
</script>
